import React from 'react';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { GrClose } from 'react-icons/gr';
import CreditCardForm from '../CreditCardForm';


function CreditCardModal({ creditCard, onSave }) {
  const body = document.getElementsByTagName('body')[0];

  const closeModal = () => {
    ModalManager.close()
    body.style.overflow = 'auto'
  }

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflowX: 'hidden',
      overflowY: 'auto',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      position: 'relative',
      border: '1px solid rgba(0, 0, 0, .2)',
      width: 'inherit',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
    }
  }



  return (
    <div className="ConfigModal">

      <Modal
        style={style}
        onRequestClose={() => { }}
        effect={Effect.Fall}>

        <div className="header">
          <div className="title">
            {creditCard.name}
          </div>

          <div className="actions">
            <GrClose onClick={closeModal} />
          </div>
        </div>

        <div className="body">
        <CreditCardForm creditCard={creditCard}/>
      </div>
      </Modal>
    </div>
  );
}

export default CreditCardModal;